import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import useTable from '../context/TableContext';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import Form from '../components/ui/Form';
import Input from '../components/ui/Input';
import Radio from '../components/ui/Radio';
import SubmitButton from '../components/ui/SubmitButton';
import TextArea from '../components/ui/TextArea';
import CheckboxBool from '../components/ui/CheckboxBool';
import Select from '../components/ui/Select';
import { addAnimal, addAnimalPhoto, addEvent, updateAnimal, findAnimals, findEvents } from '../api/api';
import Date from '../functions';
import { getProbableFathers } from '../functions/animalFunctions';

export default function FormAnimal(_route) {
    const { tableData, setTableData } = useTable();
    const { animals, events, setAnimals, locations, setEvents } = useApp();
    const addToast = useToaster();
    const [birthNum, setBirthNum] = useState(1);
    const [isLoaded, setIsLoaded] = useState(false);
    const [probableFathers, setProbableFathers] = useState([]);
    const [totalBirth, setTotalBirth] = useState(1);
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const animalObj = {
        sex: '',
        name: '',
        number: '',
        locationId: '',
        birthDate: new Date().toDateInputValue(),
        fatherId: '',
        fatherNotes: '',
        motherId: '',
        motherNotes: '',
        qualities: '',
        flaws: '',
        followed: '',
        notes: '',
        weaned: '',
        driedup: ''
    };
    const [animal, setAnimal] = useState(animalObj)
    const sexItems = [
        { id: 1, label: 'M' },
        { id: 2, label: 'F' },
        { id: 3, label: 'MC' },
    ]
    const animalEditing = _route && _route.id && animals && events && locations;
    const animalBirth = _route && _route.mother_id && animals && events && locations;

    if (animalEditing || animalBirth || (animals && events)) setIsLoaded(true);

    useEffect(() => {
        if (animalEditing) {
            const a = animals.find(animal => parseInt(animal.id) === parseInt(_route.id));
            if (a) {
                setAnimal(prevState => ({
                    ...prevState,
                    sex: a.sex,
                    name: a.name,
                    number: a.number,
                    birthDate: a.birthdayApi,
                    locationId: a.location ? a.location.id : '',
                    fatherId: a.fatherId ? a.fatherId : '',
                    fatherNotes: a.father_notes,
                    motherId: a.motherId ? a.motherId : '',
                    motherNotes: a.mother_notes,
                    qualities: a.qualities,
                    flaws: a.flaws,
                    followed: a.followed,
                    notes: a.notes,
                    weaned: typeof a.weaned == "undefined" ? true : a.weaned, //sevrée
                    driedup: typeof a.driedup == "undefined" ? true : a.driedup // tarie
                }));
            }
        }
        else if (animalBirth) {
            const mother = animals.find(a => parseInt(a.id) === parseInt(_route.mother_id));
            if (_route.nob) setTotalBirth(_route.nob);
            setProbableFathers(getProbableFathers(animals, events, mother, _route.date));
            setAnimal(prevState => ({
                ...prevState,
                motherId: _route.mother_id,
                birthDate: _route.date,
                locationId: mother.location?.id,
                weaned: false,
                driedup: true
            }));
        }
        window.scrollTo(0, 0);
    }, [])

    async function refreshAnimals() {
        const tableDataCopy = Object.assign({}, tableData);
        const displayArchive = localStorage.getItem('displayArchive') && localStorage.getItem('displayArchive') == "true";
        return await findAnimals(displayArchive).then((_animals) => {
            if (!_animals.message) {
                setAnimals(_animals);
                tableDataCopy["animals"] = _animals;
                setTableData(tableDataCopy);
                return _animals;
            }
        });
    }

    async function refreshEvents() {
        const tableDataCopy = Object.assign({}, tableData);
        await findEvents().then((events) => {
            if (!events.message) {
                setEvents(events);
                tableDataCopy["events"] = events;
                setTableData(tableDataCopy);
                return events;
            }
        });
    }

    async function addMovementEvent(animal, fields) {
        if (typeof fields.locationId == "undefined" || (fields.locationId && fields.locationId.value < 1)) return false;
        const newEvent = {
            animal: "/api/animals/" + animal.id,
            location: "/api/locations/" + fields.locationId.value,
            date: fields.birthDate.value,
            notes: 'création de l\'animal',
            type: 1
        }
        await addEvent(newEvent).then((response) => {
            if (response["@context"] == '/api/contexts/Error') {
                addToast('danger', 'Erreur lors de l\'ajout du déplacement : ' + response["hydra:description"]);
                return false;
            }
            if (response.code && response.code == '401') {
                addToast('warning', 'Vous n\'avez pas les droits pour modifier le mouvement !');
                return false;
            }
            addToast('success', 'Mouvement(s) ajouté(s)');
            return true;
        }).catch(error => {
            addToast('danger', 'Erreur lors de l\'ajout d\'un déplacement ' + error.toString());
            return false
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formAnimal = {
            sex: parseInt(fields.sex.value),
            name: fields.name.value,
            number: fields.number.value,
            birthday: fields.birthDate.value,
            father: fields.fatherId.value ? "/api/animals/" + fields.fatherId.value : null,
            fatherNotes: fields.fatherNotes.value,
            mother: fields.motherId.value ? "/api/animals/" + fields.motherId.value : null,
            motherNotes: fields.motherNotes.value,
            notes: fields.notes.value,
            qualities: fields.qualities.value,
            flaws: fields.flaws.value,
            weaned: fields.weaned.checked,
        }
        if (fields.followed) formAnimal.followed = parseInt(fields.followed.value);
        if (fields.driedup) formAnimal.driedup = fields.driedup.checked;

        if (fields.birthDate.value == '') {
            addToast('danger', 'Le champ date de naissance est obligatoire');
            return;
        }
        if (fields.name.value == '') {
            addToast('danger', 'Le champ nom est obligatoire');
            return;
        }

        setSubmitButtonDisabled(true);
        // Update the animal
        if (_route && _route.id) {
            // if we removed weaned then substract 1 from mother followed
            if (formAnimal.weaned && !weaned) {
                const mother = animals.find(a => parseInt(a.id) === parseInt(motherId));
                if (mother) {
                    const formMother = {
                        followed: mother.followed - 1
                    }
                    updateAnimal(formMother, mother.id).then((response) => {
                        if (response["@context"] && response["@context"] == '/api/contexts/Error') {
                            addToast('danger', 'Erreur lors de la mise à jour de la mère : ' + response["hydra:description"]);
                        } else if (response.code && response.code == '401') {
                            addToast('warning', 'Vous n\'avez pas les droits de modification !');
                        }
                        else {
                            addToast('success', 'Suitée -1 pour la mère avec succès');
                        }
                    }).catch(error => {
                        addToast('danger', 'Erreur lors de la mise à jour de l\'animal : ' + error.toString());
                    });
                }
            }
            updateAnimal(formAnimal, _route.id).then((response) => {
                setSubmitButtonDisabled(false);
                if (response["@context"] && response["@context"] == '/api/contexts/Error') {
                    addToast('danger', 'Erreur lors de la mise à jour de l\'animal : ' + response["hydra:description"]);
                } else if (response.code && response.code == '401') {
                    addToast('warning', 'Vous n\'avez pas les droits pour modifier la fiche animal !');
                }
                else {
                    // add a photo ?
                    if (fields.photo.value != '') {
                        var formName = document.createElement('form');
                        formName.setAttribute('name', 'AnimalPhotos');
                        const fd = new FormData(formName);
                        fd.append('animal', '/api/animals/' + _route.id);
                        fd.append('photoFile', fields.photo.files[0]);
                        addAnimalPhoto(fd).then((r) => {
                            addToast('success', 'Photo créée avec succès');
                        }).catch(error => {
                            addToast('danger', 'Erreur lors de l\'ajout de la photo : ' + error.toString());
                        });
                    }
                    refreshAnimals().then(() => {
                        addToast('success', 'Animal mis à jour');
                        history.go(-1);
                        return;
                    });
                }
            }).catch(error => {
                setSubmitButtonDisabled(false);
                addToast('danger', 'Erreur lors de la mise à jour de l\'animal : ' + error.toString());
            });

            // Add the animal
        } else {
            if (fields.locationId && fields.locationId.value) {
                formAnimal.location = "/api/locations/" + fields.locationId.value;
            }
            addAnimal(formAnimal).then((response) => {
                setSubmitButtonDisabled(false);
                if (response["@context"] == '/api/contexts/Error') {
                    addToast('danger', 'Erreur lors de l\'ajout de l\'animal : ' + response["hydra:description"]);
                } else if (response.code && response.code == '401') {
                    addToast('warning', 'Vous n\'avez pas les droits pour créer un animal !');
                }
                else {
                    addMovementEvent(response, fields).then((res) => {
                        if (res) refreshEvents();
                    });
                    addToast('success', 'Animal créé');
                    // If it's a birth, continue to a new form if it's twins or more
                    if (birthNum < totalBirth) {
                        // reset the animal
                        setAnimal(prevState => ({
                            ...prevState,
                            sex: '',
                            name: '',
                            number: '',
                            qualities: '',
                            flaws: '',
                            followed: '',
                            weaned: false,
                            driedup: true,
                            notes: ' ',
                        }));
                        if (_route.bnum) setBirthNum(parseInt(_route.bnum) + 1);
                        route('/form-animal/birth/mother/' + _route.mother_id + '/nob/' + totalBirth + '/bnum/' + (parseInt(_route.bnum) + 1) + '/date/' + _route.date);
                    }
                    else {
                        refreshAnimals().then(() => {
                            if (animalBirth) 
                                route('/animal/' + _route.mother_id);
                            else 
                                route('/animals');
                            return;
                        })
                    }
                }

            }).catch(error => {
                addToast('danger', 'Erreur lors de l\'ajout d\'un animal : ' + error.toString());
            });
        }
    }

    const handleChange = (event) => {
        let f = event.target;
        setAnimal(prevState => ({
            ...prevState,
            [f.name]: f.type == "checkbox" ? f.checked : f.value
        }));
    }

    if (!isLoaded) {
        return (
            <div class="spinner-border text-warning" role="status">
                <span class="visually-hidden">Loading form animal...</span>
            </div>
        );
    }

    const hasArchivedData = localStorage.getItem('displayArchive') && localStorage.getItem('displayArchive') == "true";
    return (
        <div key="formAnimal" class="container-md mt-2 mb-2 pb-5">
            <h1 class="text-center">{name ? name + ' (édition)' : 'Fiche animal (création) '
                + (_route.mother_id ? ', naissance ' + birthNum + '/' + _route.nob : '')}
            </h1>
            {probableFathers && probableFathers.length > 0 &&
                <div class="fathers">
                    Les pères possibles sont :
                    {probableFathers.map(a =>
                        <span> <a href={"/animal/" + a.animalId}>{a.animalName}</a> <span class="icon" onclick={() => setAnimal(ps => ({ ...ps, fatherId: a.animalId }))}>⤵️</span></span>
                    )}
                    {!hasArchivedData && <p>Attention ! Vous n'affichez pas les archives, il se peut qu'un père possible n'ait pas été détecté.</p>}
                </div>
                ||
                <div class="fathers">
                    Il n'y avait pas de père possible sur ce terrain.
                    {!hasArchivedData && <p>Attention ! Vous n'affichez pas les archives, il se peut qu'un père possible n'ait pas été détecté.</p>}
                </div>
            }
            <Form onSubmit={(handleSubmit)}>
                <Input id="name" label="Nom" type="text" value={animal.name} onInput={e => handleChange(e)} />
                <div class="container text-center">
                    <div class="row">
                        <div class="col-9 ps-0">
                            <Radio id="sex" label="Sexe" items={sexItems} value={animal.sex} onChange={e => handleChange(e)} />
                        </div>
                        <div class="col-3 pe-0">
                            <CheckboxBool id="weaned" label="Sevré" type="weaned" value={animal.weaned} onChange={e => handleChange(e)} />
                        </div>
                    </div>
                </div>
                {animal.sex == 2 &&
                    <div class="container text-center">
                        <div class="row">
                            <div class="col ps-0">
                                <Input id="followed" label="Suitée" type="number" value={animal.followed} onInput={e => handleChange(e)} />
                            </div>
                            <div class="col pe-0">
                                <CheckboxBool id="driedup" label="Tarie" type="driedup" value={animal.driedup} onChange={e => handleChange(e)} />
                            </div>
                        </div>
                    </div>
                }
                <div class="container text-center">
                    <div class="row">
                        <div class="col ps-0">
                            <Input id="number" label="Numéro" type="text" value={animal.number} onInput={e => handleChange(e)} />
                        </div>
                        <div class="col pe-0">
                            <Input id="birthDate" label="Date de naissance" type="date" value={animal.birthDate} onInput={e => handleChange(e)} />
                        </div>
                    </div>
                </div>
                {!_route.id &&
                    <Select id="locationId" label="Terrain" value={animal.locationId} onChange={e => handleChange(e)}>
                        <option value="">Aucun</option>
                        {
                            locations.map((location) => {
                                return (
                                    <option key={location.id} value={location.id}>{location.fullName}</option>
                                )
                            })
                        }
                    </Select>
                }
                <div class="container text-center">
                    <div class="row">
                        <div class="col ps-0">
                            <Select id="fatherId" label="Père" value={animal.fatherId} onChange={e => handleChange(e)}>
                                <option value="">Aucun</option>
                                {
                                    animals.map((a) => {
                                        if (a.sex == 1 || a.sex == 3) {
                                            return (
                                                <option key={a.id} value={a.id}>{a.name}</option>
                                            )
                                        }
                                    })
                                }
                            </Select>
                        </div>
                        <div class="col pe-0">
                            <TextArea id="fatherNotes" label="Notes père" value={animal.fatherNotes} onInput={e => handleChange(e)} />
                        </div>
                    </div>
                </div>
                <div class="container text-center">
                    <div class="row">
                        <div class="col ps-0">

                            <Select id="motherId" label="Mère" value={animal.motherId} onChange={e => handleChange(e)} >
                                <option value="">Aucune</option>
                                {
                                    animals.map((a) => {
                                        if (a.sex == 2) {
                                            return (
                                                <option key={a.id} value={a.id}>{a.name}</option>
                                            )
                                        }
                                    })
                                }
                            </Select>
                            {animal.motherId && <a href={"/animal/" + animal.motherId} style="text-decoration: none">↗️</a>}
                        </div>
                        <div class="col pe-0">
                            <TextArea id="motherNotes" label="Notes mère" value={animal.motherNotes} onInput={e => handleChange(e)} />
                        </div>
                    </div>
                </div>
                <Input id="qualities" label="Qualités" type="text" value={animal.qualities} onInput={e => handleChange(e)} />
                <Input id="flaws" label="Tares" type="text" value={animal.flaws} onInput={e => handleChange(e)} />
                <Input id="notes" label="Notes" type="text" value={animal.notes} onInput={e => handleChange(e)} />
                <Input id="photo" label="Ajouter une photo" type="file" onInput={e => handleChange(e)} />
                <SubmitButton disabled={submitButtonDisabled} />
            </Form>
        </div>
    );
}